import React from 'react'
import styled from '@emotion/styled'
import { fontSize2XLarge, fontSizeMedium, fontSizeXSmall, greenLight } from '../../constants/principles'
import { formatPrice } from '../../utils/kbbUtils'

export default function({ dealerName, markupAmount }) {
  const markupAmountFormated = formatPrice(markupAmount)
  return (
    <MainDiv>
      <Heading data-testid ={`oc-boost-box`}>You Received A Dealer Boost!</Heading>
      <SubHeading data-testid ={`oc-boost-box-dealer-name`}>Only at {dealerName}</SubHeading>
      <OfferDiv data-testid ={`oc-boost-box-amount`}>{markupAmountFormated}</OfferDiv>
    </MainDiv>
  )
}

const MainDiv = styled.div`
  background-color: ${greenLight};
  border-radius: 10px;
  margin-top: 20px;
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 10px 0;
`
const Heading = styled.div`
  font-size: ${fontSizeMedium};
  font-weight: 600;
`
const SubHeading = styled.div`
  font-size: ${fontSizeXSmall};
`
const OfferDiv = styled.div`
  font-size: ${fontSize2XLarge};
  font-weight: 700;
  line-height: 1;
`
